export const language = {
  zh: {
    'Contact Us': '联系我们',
    'Tel No.': '联系电话',
    'Email': '邮箱',
    'Log out': '退出登录',
    'Change Password': '修改密码',
    'Company Management': '公司管理',
    'Check the progress of application': '查看审批进度',
    'Apply to be a Supplier': '申请成为供应商',
    'Supplier Center': '供应商中心',
    'On Lining': '该功能即将上线',
    'Log in': '登录',
    'Ship to': '可销往国家',
    'Create': '注册',
    'Buyer Center': '买家中心',
    'Language': '语言',
    'Currency': '币种',
    'Related Applications': '相关应用',
    'CNY-RMB': 'CNY-人民币',
    'USD-US Dollar': 'USD-美元',
    'save': '保存',
    'CP Quality Inspection': '正大质检小程序',
    'Administrators': '管理员',
    'Agency Operations': '代运营',
    'Collect List': '收藏清单',
    'Cart': '购物车',
    'Smart AI': '智能AI',
    'CP GSP mini program': 'CP采购平台小程序',
    'Switch company': '切换公司',
    'Message Center': '消息中心',
    'Allocation Center': '调配中心',
  },
  en: {
    'Contact Us': 'Contact Us',
    'Tel No.': 'Tel No.',
    'Email': 'Email',
    'Log out': 'Log out',
    'Change Password': 'Change Password',
    'Company Management': 'Company Management',
    'Check the progress of application': 'Check the progress of application',
    'Apply to be a Supplier': 'Apply to be a Supplier',
    'Supplier Center': 'Supplier Center',
    'On Lining': 'On Lining',
    'Log in': 'Log in',
    'Language': 'Language',
    'Currency': 'Currency',
    'CNY-RMB': 'CNY-RMB',
    'USD-US Dollar': 'USD-US Dollar',
    'Ship to': 'Ship to',
    'save': 'save',
    'Create': 'Create',
    'Buyer Center': 'Buyer Center',
    'Related Applications': 'Related Applications',
    'CP Quality Inspection': 'CP Quality Inspection',
    'Administrators': 'Administrators',
    'Agency Operations': 'Agency Operations',
    'Collect List': 'Collect List',
    'Cart': 'Cart',
    'Smart AI': 'Smart AI',
    'CP GSP mini program': 'CP GSP mini program',
    'Switch company': 'Switch company',
    'Message Center': 'Message Center',
    'Allocation Center': 'Allocation Center',
  }
};
